import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { clsx } from 'clsx'
import { Check, ChevronLeft } from '@/assets/icons'
import { useAppSelector } from '@/store/store-hooks'
import { selectMoveChatDestinationsMattersSortedByName } from '@/matter/store/selectors'
import { kMoveToMatterLabel } from '@/matter/constants'

type MobileMatterSubMenuContentProps = {
  handleMatterSelect: (toMatterId: string, toMatterName?: string) => void
  fromMatterId: string | null
  setMattersContentOpen: (open: boolean) => void
}

export const MobileMatterSubMenuContent: React.FC<MobileMatterSubMenuContentProps> = ({ handleMatterSelect, fromMatterId, setMattersContentOpen }) => {
  const matters = useAppSelector(selectMoveChatDestinationsMattersSortedByName)
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        className="z-50 min-w-[130px] bg-white rounded-lg border shadow-[0_0_6px_-2px_rgba(0,_0,_0,_0.05),_0_0_15px_-3px_rgba(0,_0,_0,_0.10)] will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade max-h-[min(var(--radix-popper-available-height))] max-w-[min(260px,var(--radix-popper-available-width))] overflow-y-auto"
        collisionPadding={8}
      >
        {/* Header */}
        <div className="group flex items-center justify-start gap-1 text-brand-neutral-950 p-2">
          <button
            onClick={(e) => {
              setMattersContentOpen(false)
              e.stopPropagation()
            }}
            className="flex items-center gap-1"
          >
            <ChevronLeft className="w-5 h-5 group-hover:text-brand-500 group-focus:text-brand-500 group-data-[highlighted]:text-brand-500 group-data-[state=open]:text-brand-500" />
            <span className="text-sm font-semibold group-hover:text-brand-500 group-focus:text-brand-500 group-data-[highlighted]:text-brand-500 group-data-[state=open]:text-brand-500">
              {kMoveToMatterLabel}
            </span>
          </button>
        </div>
        <DropdownMenu.Separator className="bg-brand-neutral-200 w-full h-px mb-1" />
        {/* Content */}
        <div className="overflow-y-auto p-2">
          <ul role="list" className="flex flex-col gap-2 mb-1">
            {matters.map((matter) => (
              <li key={matter.id} role="none">
                <DropdownMenu.Item
                  className={clsx(
                    'group flex items-center gap-2.5 p-2 rounded-md text-sm leading-6 w-full focus:outline-none cursor-pointer hover:bg-brand-neutral-100 focus:bg-brand-neutral-100 mb-1 last:mb-0',
                    fromMatterId === matter.id && 'bg-brand-neutral-100 text-brand-500'
                  )}
                  onClick={(e) => {
                    // Stop the event from bubbling up to the parent
                    e.stopPropagation()

                    handleMatterSelect(matter.id, matter.name)
                  }}
                >
                  <span className="whitespace-nowrap group-hover:text-brand-500 truncate">{matter.name}</span>
                  {fromMatterId === matter.id && <Check className="w-4 h-4 shrink-0 text-brand-500" />}
                </DropdownMenu.Item>
              </li>
            ))}
          </ul>
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  )
}
